import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Step 1: Donor personal information
interface DonorInfo {
  name: string;
  email: string;
  mobile: string;
  aadharNo: string;
  pan: string;
  address: string;
  Mailotp: string;
  pinCode: string;
  districtName: string;
  stateName: string;
  panFile: string | File | null;
  aadharFile: string | File | null;
  agreed: boolean;
  gst: string;
  gstCertificateBase64: string | File | null;
  profilePhoto: string | File | null;
}

// Step 2: Bank information
interface DonorBank {
  name: string;
  account: string;
  ifsc: string;
  username: string;
  cheque: string | File | null;
  isDefault: boolean;
}

// Combined donor form state
interface DonorFormState {
  donorInfo: DonorInfo;
  banks: DonorBank[];
}

// Initial state
const initialState: DonorFormState = {
  donorInfo: {
    name: '',
    email: '',
    mobile: '',
    aadharNo: '',
    pan: '',
    address: '',
    Mailotp: '',
    pinCode: '',
    districtName: '',
    stateName: '',
    panFile: null,
    aadharFile: null,
    agreed: false,
    gst: '',
    gstCertificateBase64: null,
    profilePhoto: null,
  },
  banks: [
    {
      name: '',
      account: '',
      ifsc: '',
      username: '',
      cheque: '',
      isDefault: true,
    },
  ],
};

const donorIndiviSlice = createSlice({
  name: 'donorForm',
  initialState,
  reducers: {
    updateDonorInfo: (state, action: PayloadAction<Partial<DonorInfo>>) => {
      state.donorInfo = { ...state.donorInfo, ...action.payload };
    },
    updateDonorBanks: (state, action: PayloadAction<DonorBank[]>) => {
      state.banks = action.payload;
    },
    clearDonorForm: () => initialState,
  },
});

export const {
  updateDonorInfo,
  updateDonorBanks,
  clearDonorForm,
} = donorIndiviSlice.actions;

export default donorIndiviSlice.reducer;
